module.exports = __webpack_public_path__ + "static/media/SafeTraces_Logo.Horiz.96beedfd.png";